import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getPmtaConfig(id) {
        return axios.get(config.publicPath + 'pmta_configs/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getPmtaConfigs(currentPage, perPage, orderField, orderDirection, type, name) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            type: type,
            name: name
        };
        parameters['order[' + orderField +']'] = orderDirection;
        return axios.get(config.publicPath + 'pmta_configs', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getPmtaConfigSelect(type) {
        return axios.get(config.publicPath + 'pmta_configs', {
            params: {'groups[]': 'select', 'pagination': false, type: type},
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    createPmtaConfig(formData) {
        return axios.post(config.publicPath + 'pmta_config/create', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updatePmtaConfig(id, formData) {
        return axios.post(config.publicPath + 'pmta_config/' + id + '/update', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deletePmtaConfig(id) {
        return axios.delete(config.publicPath + 'pmta_config/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getPmtaConfigContent(id) {
        return axios.get(config.publicPath + 'pmta_config/' + id + '/content', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getTypeList() {
        return axios.get(config.publicPath + 'pmta_config/types', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getAppliedConfigs(filter, order) {
        let cleanFilter = [];
        Object.keys(filter).forEach(key => {
            if (null !== filter[key] && undefined !== filter[key]) {
                cleanFilter.push({"field": key, "value": filter[key]})
            }            
        });
        let queryData = new FormData();
        queryData.append('filter', JSON.stringify(cleanFilter));
        queryData.append('order', JSON.stringify(order));

        return axios.post(config.publicPath + 'applied_pmta_configs', queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteAppliedConfigs(ids) {
        let queryData = new FormData();
        queryData.append('ids', JSON.stringify(ids));
        return axios.post(config.publicPath + 'applied_pmta_configs/delete', queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    resetCurrentVersion(ids) {
        let queryData = new FormData();
        queryData.append('ids', JSON.stringify(ids));
        return axios.post(config.publicPath + 'applied_pmta_configs/reset_current_version', queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    applyConfigTo(pmtaConfig, recipients) {
        let queryData = new FormData();
        queryData.append('config', JSON.stringify(pmtaConfig));
        queryData.append('recipients', JSON.stringify(recipients));
        return axios.post(config.publicPath + 'pmta_config/apply', queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    }
}
